// extracted by mini-css-extract-plugin
export default {"container":"branchStockTables_container__sIpgl","lotContainer":"branchStockTables_lotContainer__w6RoG","table":"branchStockTables_table__wpUlH"};